import { render, staticRenderFns } from "./FinishRecord.vue?vue&type=template&id=7a73fc5e&"
import script from "./FinishRecord.vue?vue&type=script&lang=ts&"
export * from "./FinishRecord.vue?vue&type=script&lang=ts&"
import style0 from "./FinishRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports